export default class Header {
    /**
     * Column title
     */
    title;
    value;
    sortable;
    align;
    minWidth;
    canBeFiltered;
    /**
     * Function that takes an item and returns a string that should be rendered.
     */
    displayMapping;
    /**
     * Specifies additional params for export to Excel
     */
    exportOptions;
    filterOptions;
    /**
     * Specifies the filters displayed in the filter bar.
     */
    filter;
    /**
     * If true, header/cell will not be rendered.
     */
    isHidden;
    /**
     *  If true, Header cannot be moved or hidden.
     */
    isFixed;
    /**
     *  If true, sets cellProps to 'status-cell' and class to 'status header'.
     */
    isStatusCell;
    /**
     * Additional props for cell
     */
    cellProps;
    /**
     * Additional props for header
     */
    headerProps;
    /**
     * If true, column can be hidden/shown via UI.
     */
    canBeToggled;
    constructor({ title = undefined, value = undefined, sortable = false, align = undefined, minWidth = undefined, displayMapping = undefined, exportOptions = undefined, filterOptions = undefined, filter = undefined, isHidden = false, isFixed = false, isStatusCell = false, cellProps = null, headerProps = null, canBeToggled = true, } = {}) {
        this.title = title;
        this.value = value;
        this.align = align;
        this.minWidth = minWidth;
        this.sortable = sortable;
        this.displayMapping = displayMapping;
        this.exportOptions = exportOptions;
        this.filterOptions = filterOptions;
        this.filter = filter;
        this.isHidden = isHidden;
        this.isStatusCell = isStatusCell;
        this.isFixed = isStatusCell || isFixed;
        this.canBeToggled = canBeToggled;
        this.canBeFiltered = filterOptions !== undefined && !filterOptions.isHidden;
        this.cellProps = (cellProps ?? (isStatusCell ? { class: 'status-cell' } : undefined)) ?? undefined;
        this.headerProps = (headerProps ?? (isStatusCell ? { class: 'status-header' } : undefined)) ?? undefined;
    }
}
;
export class ExportOptions {
    /**
     * If passed, this function will be used to format the cell before exporting.
     */
    formatData;
    /**
     * If true, cell will not be exported.
     */
    isIgnored = false;
    /**
     * If true, cell will be exported. Has more priority than isHidden of the header.
     */
    forcedExport = false;
    /**
     * If set, exactly this string will be used instead of header.title.
     */
    headerText;
    constructor(init) {
        Object.assign(this, init);
    }
}
